module.exports = {"361028100":"鹤城镇","361028101":"马头山镇","361028102":"高阜镇","361028103":"嵩市镇","361028104":"乌石镇","361028200":"高田乡","361028201":"石峡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361028.json
// module id = 1336
// module chunks = 0